import { defineFcm } from '../shared/factory';

export const FCM_SPH_CONTACT_DECISION_MAKER_SPEAK_UP_CTA_ENABLED = defineFcm(
	'sph_contact_decision_maker_speak_up_cta_enabled',
)
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-vaquita',
		scope: 'corgi-front-end',
		context: 'Supporter → DM Outreach',
		description:
			'Enables the sph_contact_decision_maker_speak_up_cta experiment (CHANGE-100466): "Speak up" vs ' +
			'"Contact {name}" on the Signed Petition Home contact-decision-maker checklist CTA. The experiment is ' +
			'also limited to the en-US locale in its config. Off, every viewer sees the current label.',
	});
